// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__KDEGd","container":"Footer_container__LgJl3","link":"Footer_link__MRbrh"};